import { lang } from '../config/app.config';
import { httpbase } from '../utils/axios.utils';

export const fetchLocalElectionTimer = async () => {
  try {
    const response = await httpbase().get(`/election-deadline?lang=${lang}`);
    return response?.data?.data;
  } catch (e) {
    console.log(e);
    return
  }
}